export default __webpack_public_path__ + "static/media/1137.71cc6ecd.png";